import { render, staticRenderFns } from "./BaseChatMessageIcon.vue?vue&type=template&id=3e9b332f&scoped=true&"
import script from "./BaseChatMessageIcon.vue?vue&type=script&lang=js&"
export * from "./BaseChatMessageIcon.vue?vue&type=script&lang=js&"
import style0 from "./BaseChatMessageIcon.vue?vue&type=style&index=0&id=3e9b332f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9b332f",
  null
  
)

export default component.exports